import { render, staticRenderFns } from "./SalaryPeriods.vue?vue&type=template&id=04b7127d&scoped=true"
import script from "./SalaryPeriods.vue?vue&type=script&lang=js"
export * from "./SalaryPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7127d",
  null
  
)

export default component.exports